export default __webpack_public_path__ + "static/media/poseTime.e85706eb.svg";